import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router/index';
import config from './config/config';
import AppConfig from './data/app-config';

import store from './store/index';
import i18n from "./lang/index";
import globalRegist from './plugins/globalRegist';
import FastClick from 'fastclick';
import 'lib-flexible/flexible';
import cookie from "./utils/cookie";
import VConsole from 'vconsole';
import dsBridge from 'dsbridge';

Vue.use(globalRegist);
Vue.config.silent = true;
Vue.config.productionTip = false;
AppConfig.getConfig().then(d=>{
    Object.assign(config, d);
    Vue.prototype.$config = config
    router.beforeEach(async (to, from, next) => {
        let loginInfo = JSON.parse(window.dsBridge.call('getLoginMsg') || '{}');
        i18n.locale = loginInfo.langType || cookie.get("lang") || 'en-US';
        // 初始化vconsole
        let is_vconsole = localStorage.getItem('vconsole');
        if(is_vconsole && is_vconsole === 'true') {
            const vConsole = new VConsole();
            Vue.use(vConsole);
        }

        /*
        * 取消上一页面的网络请求
        * */
        /*(window._axiosPromiseArr || []).forEach((ele, index) => {
            ele.cancel();
            delete window._axiosPromiseArr[index];
        });*/

        /*if(navigator.onLine) {
            next();
        } else {
            next(false);
            router.push({
                name: 'net-error'
            });
        }*/
        try {
            next();
        } catch(error){
            next(error);
        }
    });

    router.afterEach((to, from) => {
    });

    /*
    * 如果路由加载时出现 Loading chunk xx failed 错误时重新加载当前路由
    * */
    router.onError(error => {
        let regx = /Loading chunk (\d)+ failed/g;
        let isChunkLoadFailed = error.message.match(regx);
        let targetPath = router.history.pending.fullPath;
        if(isChunkLoadFailed) {;;
            router.replace(targetPath);
        }
    });

    FastClick.attach(document.body);

    new Vue({
        store,
        i18n,
        router,
        render: h => h(App)
    }).$mount('#app-box');
},err=>{});



// WEBPACK FOOTER //
// ./src/main.js